import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/utils';
import { useSupportIdentity } from '../../../stores/appSupportStore';
import { borderGrey, primaryText } from '../../../styling/stylingHelper';
import { SupportDrawer } from './SupportDrawer';
import { useSupportDraftGuard } from './useSupportDraftGuard';

export default function AdminSetupSupport(props: { restaurantId: string; restaurantName?: string }) {
  const identity = useSupportIdentity();
  return identity ? <AdminSetupSupportSession key={`${identity}:${props.restaurantId}`} {...props} /> : null;
}

function AdminSetupSupportSession({ restaurantId }: { restaurantId: string }) {
  const { t } = useTranslation('support');
  const [drawer, setDrawer] = useState<{ view: 'new' | 'submitted'; threadId: string | null } | null>(null);
  const dirty = useRef(false);
  useSupportDraftGuard(dirty, t('discardDraft'));
  const navigate = (view: 'new' | 'submitted', threadId?: string) => {
    if (drawer?.view === view && drawer.threadId === (threadId ?? null)) return;
    if (dirty.current && !window.confirm(t('discardDraft'))) return;
    dirty.current = false;
    setDrawer({ view, threadId: threadId ?? null });
  };
  const button = cn('min-h-[44px] rounded-xl border px-4 py-2 text-sm', borderGrey, primaryText);
  return <>
    <div className="flex flex-wrap gap-2">
      <button type="button" className={button} onClick={() => navigate('new')}>{t('admin.messageCustomer')}</button>
      <button type="button" className={button} onClick={() => navigate('submitted')}>{t('submitted')}</button>
    </div>
    {drawer && <SupportDrawer {...drawer} type="support" adminSetup={{ restaurantId }}
      onNavigate={navigate} onDraftChange={value => { dirty.current = value; }}
      onClose={() => { if (!dirty.current || window.confirm(t('discardDraft'))) { dirty.current = false; setDrawer(null); } }} />}
  </>;
}
